"use client"

import * as React from "react"
import styled from "styled-components"

interface NumericBadgeProps {
  /**
   * The number to display in the badge
   */
  number: number
  /**
   * Optional className for additional styling
   */
  className?: string
}

const Badge = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 27px;
  background-color: #4c607e;
  overflow: hidden;
  font-size: 12px;
  color: #fff;
  font-weight: 300;
  white-space: nowrap;
  text-align: center;
  line-height: 1.3;
  width: 16px;
  height: 16px;
  min-width: 16px;
  user-select: none;
`

const NumericBadge: React.FC<NumericBadgeProps> = ({ number, className }) => {
  return (
    <Badge className={className} role="status" aria-label={`Count: ${number}`}>
      {number}
    </Badge>
  )
}

export default NumericBadge
